const zhLang = require('./zh.json')
const cnLang = require('./cn.json')
const enLang = require('./en.json')
const thLang = require('./th.json')
const viLang = require('./vi.json')

export default {
  zh: zhLang,
  cn: cnLang,
  en: enLang,
  th: thLang,
  vi: viLang
}
